var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVochtigheid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35.3 35.3",
    style: {
      enableBackground: "new 0 0 35.3 35.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#33ADA3;stroke-width:1.35;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#F28F39;stroke-width:1.35;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#E8553F;stroke-width:1.35;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#E8553F;}\n\t.st4{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.8,19.8c-1.7-5.9-9.1-13.6-10.4-17.4C11.9,6.7,2.6,16.2,2.6,22.2c0,6,4.9,10.8,10.8,10.8 c4.3,0,8-2.5,9.7-6.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.1,2.3c-0.5,1.5-3.8,4.9-3.8,7c0,2.1,1.7,3.8,3.8,3.8s3.8-1.7,3.8-3.8C31.9,7.1,28.6,3.8,28.1,2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.4,20c2.4,0,2.4-2.1,4.8-2.1c2.4,0,2.4,2.1,4.8,2.1c2.4,0,2.4-2.1,4.8-2.1c2.4,0,2.4,2.1,4.8,2.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.4,25.3c2.4,0,2.4-2.1,4.8-2.1c2.4,0,2.4,2.1,4.8,2.1c2.4,0,2.4-2.1,4.8-2.1c2.4,0,2.4,2.1,4.8,2.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVochtigheid);
export default __webpack_public_path__ + "static/media/vochtigheid.439e2410aa7945781d7882afc0f12b3b.svg";
export { ForwardRef as ReactComponent };